import { useEffect, useRef } from 'react'
import type { TooltipProps } from './types'

export type CustomTooltipProps = {
  _onMouseEnter: () => void
  _onMouseLeave: () => void
  matches: () => boolean
}

const Tooltip = ({ title, children, position = 'bottom', enabled = true }: TooltipProps) => {
  const tooltipRef = useRef<HTMLElement & CustomTooltipProps>(null)

  useEffect(() => {
    if (enabled) {
      const isHover = tooltipRef.current?.matches?.(':hover')
      if (tooltipRef.current && isHover) {
        tooltipRef.current?._onMouseLeave?.()
        tooltipRef.current?._onMouseEnter?.()
      }
    }
  }, [title, enabled])

  if (!enabled) {
    return <>{children}</>
  }

  return (
    <hot-tooltip data-test="tooltip-component" content={title} position={position} ref={tooltipRef}>
      {children}
    </hot-tooltip>
  )
}

export default Tooltip
